import { Injectable } from "@angular/core";
import Swal, { SweetAlertIcon } from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private show(
    icon: SweetAlertIcon,
    title: string,
    message = "",
    duration = 4500,
  ): void {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon,
      title,
      text: message,
      showConfirmButton: false,
      showCloseButton: true,
      timer: duration,
      timerProgressBar: true,
      customClass: {
        popup: "gloget-toast",
        title: "gloget-toast-title",
        htmlContainer: "gloget-toast-message",
        icon: "gloget-toast-icon",
        timerProgressBar: "gloget-toast-progress",
        closeButton: "gloget-toast-close",
      },
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
  }

  success(title: string, message = ""): void {
    this.show("success", title, message, 3500);
  }

  error(title: string, message = ""): void {
    this.show("error", title, message, 6500);
  }

  warning(title: string, message = ""): void {
    this.show("warning", title, message, 5000);
  }

  info(title: string, message = ""): void {
    this.show("info", title, message, 4000);
  }
}